import React, { useState } from "react";
import moment from "moment"; // Import moment để xử lý ngày
import { DatePicker, Select } from "antd"; // Import DatePicker từ antd
import { useTranslation } from "react-i18next";
import { roomOptions } from "./BookingForm";
import { sanh } from "../assets/images";
const PromotionsForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    roomType: null,
    quantity: "",
    date: null,
  });
  const { t } = useTranslation();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "quantity" && value < 0) {
      return;
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleDateChange = (date, dateString) => {
    // dateString sẽ có định dạng "DD/MM/YYYY"
    setFormData((prevData) => ({
      ...prevData,
      date: dateString, // Lưu chuỗi ngày dạng "DD/MM/YYYY"
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage(""); // Reset message

    // Basic form validation
    const { name, phone, email, roomType, quantity, date } = formData;

    // Check if any required field is empty
    if (!name || !phone || !email || !roomType || !quantity || !date) {
      setMessage("Vui lòng điền đầy đủ thông tin trước khi đặt phòng.");
      setIsSubmitting(false);
      return;
    }

    const payload = {
      ...formData,
      bookingDate: date, // Sử dụng trực tiếp date dạng "DD/MM/YYYY"
      date: date,
    };

    try {
      // Send the API request
      const response = await fetch(
        "http://103.45.232.48:10002/api/send-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        setMessage("Đặt phòng thành công!");
        // Reset the form data after successful submission
        setFormData({
          name: "",
          phone: "",
          email: "",
          roomType: null,
          quantity: "",
          date: null, // Reset về null
        });
      } else {
        setMessage("Đã xảy ra lỗi khi gửi form. Vui lòng thử lại.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setMessage("Không thể kết nối đến server. Vui lòng thử lại sau.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-8 px-4 md:px-8 flex flex-col lg:flex-row items-start space-y-6 lg:space-y-0 lg:space-x-8">
      {/* Left Section: Image and Promotion Details */}
      <div className="w-full lg:w-2/3">
        {/* Image */}
        <div className=" relative w-full lg:h-[535px] ssx:h-[300px]">
          <img
            src={sanh}
            alt="Hotel Lobby"
            className="w-full h-full rounded-md object-cover absolute"
          />
          <div className="bg-black w-full h-full absolute opacity-[0.2] rounded"></div>
        </div>
        {/* Promotion Details */}
        {/* <div className="mt-4 text-gray-800">
          <ul className="list-none space-y-2">
            <li className="flex items-start">
              <span className="text-blue-500 mr-2">✓</span>
              <span>{t("PROMOTION_1")}</span>
            </li>
            <li className="flex items-start">
              <span className="text-blue-500 mr-2">✓</span>
              <span>{t("PROMOTION_2")}</span>
            </li>
          </ul>
        </div> */}
      </div>

      {/* Right Section: Booking Form */}
      <div className="w-full lg:w-1/3 bg-gray-50 p-6 rounded-md shadow-md  font-cormorant">
        <h2 className="text-xl font-bold text-gray-800 mb-4 font-cormorant">
          {t("BOOK_NOW")}
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder={t("FULL_NAME")}
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500"
            />
          </div>
          <div>
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder={t("PHONE_NUMBER")}
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500"
            />
          </div>
          <div className="input-promotion-select">
            <Select
              name="roomType"
              value={formData?.roomType}
              onChange={(value) =>
                setFormData((prevData) => ({
                  ...prevData,
                  roomType: value,
                }))
              }
              allowClear
              
              options={roomOptions}
              showSearch
              placeholder={t("SELECT_ROOM_TYPE")}
              className=" w-full  border border-gray-300 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500  font-cormorant"
              required
            />
          </div>
          <div>
            <input
              type="number"
              name="quantity"
              value={formData.quantity}
              onChange={handleChange}
              min="0"
              placeholder={t("numberPatient")}
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500"
            />
          </div>
          <div>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email"
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500"
            />
          </div>
          <div className="input-promotion-date">
            <DatePicker
              format="DD/MM/YYYY" // Định dạng hiển thị và giá trị trả về
              onChange={handleDateChange}
              value={formData.date ? moment(formData.date, "DD/MM/YYYY") : null} // Chuyển chuỗi thành moment object
              placeholder={t("selectDate")}
              className="w-full p-3 border border-gray-300 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500 "
            />
          </div>
          <button
            type="submit"
            className="w-full bg-[#D4AF37] text-black font-semibold py-3 rounded-md hover:bg-yellow-600 transition font-cormorant"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Đang xử lý..." : t("BOOK_NOW")}
          </button>
        </form>
        {message && <p className="mt-4 text-center text-red-500">{message}</p>}
      </div>
    </section>
  );
};

export default PromotionsForm;
